//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data(){
    return {
      current: "2017-11-22"
    }
  },
  methods:{
    handlerClear(){
      this.current = "";
    }
  }
}



// WEBPACK FOOTER //
// ./example/pages/datetime-selector.vue